import React from 'react'
import Layout from '../../Components/Layout'
import BannerGlobal from '../../Components/BannerGlobal'
import Projects from '../../Components/Projects'
import useDocumentTitle from '../../Hooks/PageTitle'

const ProjectPage = () => {
  useDocumentTitle("TRoo Web Design Agency | Projects Page")
  return (
    <Layout>
        <BannerGlobal/>
        <Projects/>
    </Layout>
  )
}

export default ProjectPage